import { SwingGuideLauncher } from '@blocks';

export const SwingModalLauncher = () => <SwingGuideLauncher />;
